export const FETCH_DICTATION_COMMENTS = "FETCH_DICTATION_COMMENTS";
export const FETCH_DICTATION_COMMENTS_START = "FETCH_DICTATION_COMMENTS_START";
export const FETCH_DICTATION_COMMENTS_SUCCESS = "FETCH_DICTATION_COMMENTS_SUCCESS";
export const FETCH_DICTATION_COMMENTS_ERROR = "FETCH_DICTATION_COMMENTS_ERROR";
export const ADD_DICTATION_COMMENTS = "ADD_DICTATION_COMMENTS";
export const ADD_DICTATION_COMMENTS_START = "ADD_DICTATION_COMMENTS_START";
export const ADD_DICTATION_COMMENTS_SUCCESS = "ADD_DICTATION_COMMENTS_SUCCESS";
export const ADD_DICTATION_COMMENTS_ERROR = "ADD_DICTATION_COMMENTS_ERROR";

export const fetchDictationComments = (reportId) => {
    return {
        type: FETCH_DICTATION_COMMENTS,
        reportId,
    };
}

export const addDictationComments = (data) => {
    return {
        type: ADD_DICTATION_COMMENTS,
        data,
    };
}